import { useEffect } from "react";
import { Route, Switch, useLocation, useParams } from "wouter";
import { UserView } from "./user.view";

function RedirectToGroupRoot() {
  const params = useParams<{ groupUuid: string }>();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (!params.groupUuid) return;
    navigate(`~/ram/group/${params.groupUuid}`, { replace: true });
  }, [navigate, params.groupUuid]);

  return null;
}

export function UserRoutes() {
  return (
    <Switch>
      <Route path={"/"} component={UserView} />
      <Route component={RedirectToGroupRoot} />
    </Switch>
  );
}
